import { render, staticRenderFns } from "./VentaV.vue?vue&type=template&id=13432f44"
import script from "./VentaV.vue?vue&type=script&lang=js"
export * from "./VentaV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports